// Local lesson landing pages for Dartford, Kent (online across the UK, in person in Dartford).
const AREA = "Dartford, Kent";
export const LOCAL_PAGES = {
  "piano-lessons-dartford": {
    subject: "Piano lessons", h1: `Piano lessons in ${AREA} and online`,
    description: `Piano lessons with music teacher Jason Thompson — in person in ${AREA}, or online anywhere in the UK. Learn to read music, play by ear and gospel piano.`,
    points: ["Beginner to Advanced, at your own pace", "Learn to read music and play by ear", "Gospel piano courses after the main course", "Play-along tracks in your own key and tempo"],
    course: "/instruments/pianists",
  },
  "singing-lessons-dartford": {
    subject: "Singing lessons", h1: `Singing lessons in ${AREA} and online`,
    description: `Singing lessons with Jason Thompson — in person in ${AREA}, or online anywhere in the UK. Learn to read music, sing in tune and sing your part in a choir.`,
    points: ["Read music written for voice in both clefs", "Sol-fa, pitch and ear training", "Choir part practice for every voice", "Play-along tracks in your own key"],
    course: "/instruments/singers",
  },
  "music-theory-lessons-dartford": {
    subject: "Music theory lessons", h1: `Music theory lessons in ${AREA} and online`,
    description: `Music theory lessons with Jason Thompson — in person in ${AREA}, or online anywhere in the UK, for piano, voice, guitar and drums.`,
    points: ["Treble and bass clef, note values and rests", "Tones, semitones, sharps and flats", "Scales, triads and time signatures", "Printable worksheets and quick quizzes"],
    course: "/courses",
  },
};
export const LOCAL_AREA = AREA;
